import React, { FunctionComponent } from "react";
import { IProfileRecord, IGPSData } from "../../../../Models/Models";
import { IdealVisitorSegments } from "./IdealVisitorSegments";
import HHCharChartCharts from "./HHCharChartCharts";
import { DigitalShareAppType } from "../../../../Enums/DigitalShareAppType";
import { DigitalShareItemType } from "../../../../Enums/DigitalShareItemType";

import {
    ReportH1,
    ReportScrollableSection,
    ReportSectionNumber,
    ReportSectionHeader,
    AnimatedReportCard,
} from "../../../Common";
import { RenderType } from "../../../../Enums/RenderType";

interface HHCharProps {
    location1Name: string;
    location2Name?: string;
    storeProfileData: IProfileRecord[];
    storeData: IGPSData;
    benchmarkData?: IGPSData;
    benchmarkProfileData?: IProfileRecord[];
    renderType: RenderType;
    app: DigitalShareAppType;
}

export const HHChar: FunctionComponent<HHCharProps> = (props: HHCharProps) => {
    return (
        <ReportScrollableSection id="GPSHHChar">
            <ReportSectionHeader>
                <ReportSectionNumber>02</ReportSectionNumber>
                <ReportH1>Household Characteristics</ReportH1>
            </ReportSectionHeader>
            <AnimatedReportCard
                scrollableParentSelector="#GPSReportBody"
                animateIn="zoomIn"
                offset={100}
                animateOnce={true}
            >
                <IdealVisitorSegments
                    {...props}
                    app={DigitalShareAppType.Mobilytics}
                    itemType={DigitalShareItemType.PsychographicSummary}
                />
                <HHCharChartCharts {...props} />{" "}
                {/* ERY: I'm aware this is a dumb name, but I like to say it and there are a lot of charts in here */}
            </AnimatedReportCard>
        </ReportScrollableSection>
    );
};
